import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import ModalContainer from '../../containers/ModalContainer';
import { MainButton } from '../../../inputs/buttons/MainButton';
import { InputLoadImages } from '../../../inputs/InputLoadImages';

// Styled Components
import { Container, ContainerButtons, StyledButton, Title } from './styles';

// Types
import { ModalProps } from './types';

export const AddMediaModal = ({
  onClickClose,
  choosePic,
  openCamera,
  images,
  onRemoveImage,
  onConfirm,
  ...props
}: ModalProps): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation(['modals', 'common']);
  return (
    <ModalContainer width={40} onClickClose={onClickClose} fill={theme.colors.black}>
      <Container {...props}>
        <Title variant="semiBold">{t('addMedia.title')}</Title>
        {/* Pila de lo ya capturado. Sin `images` el modal es el de siempre —
            es lo que mantiene intactos Actuación y Accidente. Con ella, el
            operario ve la foto que acaba de hacer sin salir del modal, en vez
            de tener que guardar e ir a la página Multimèdia para comprobar si
            salió movida. */}
        {!!images?.length && (
          <InputLoadImages imageData={images} removeItem={onRemoveImage} />
        )}
        <ContainerButtons>
          <StyledButton text={t('addMedia.openCamera')} onClick={openCamera} />
          <MainButton
            variant="secondary"
            text={t('addMedia.chooseFromGallery')}
            onClick={choosePic}
          />
          {!!images?.length && onConfirm && (
            <StyledButton
              text={t('common:buttons.add')}
              data-testid="add-media-confirm"
              onClick={onConfirm}
            />
          )}
        </ContainerButtons>
      </Container>
    </ModalContainer>
  );
};
